var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isActive
      ? _c("div", {
          staticClass: "click-area",
          on: { click: _vm.toggleDropdown },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "category-filter" }, [
      _vm.value.length && !_vm.isActive
        ? _c(
            "span",
            {
              staticClass: "clear",
              on: {
                click: function ($event) {
                  return _vm.selectItem("_clear_")
                },
              },
            },
            [_vm._v("clear")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isActive
        ? _c(
            "span",
            {
              staticClass: "close",
              on: {
                click: function ($event) {
                  return _vm.toggleDropdown()
                },
              },
            },
            [_vm._v("X\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticClass: "dropdown",
          class: { active: _vm.isActive },
          attrs: { id: "container" },
        },
        [
          _c(
            "li",
            [
              _vm.value != ""
                ? [
                    _c(
                      "div",
                      {
                        key: 1,
                        staticClass: "selected-filter-tags",
                        on: {
                          click: function ($event) {
                            return _vm.toggleDropdown()
                          },
                        },
                      },
                      _vm._l(_vm.value, function (name, index) {
                        return _c(
                          "span",
                          { key: index, staticClass: "filter-tag" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(name) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                : [
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.toggleDropdown()
                          },
                        },
                      },
                      [_vm._v("\n            Select Options\n          ")]
                    ),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          _vm._l(_vm.items, function (item, index) {
            return _c(
              "li",
              {
                key: index,
                class: { active: _vm.value.includes(item) },
                on: {
                  click: function ($event) {
                    return _vm.selectItem(item)
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(item) + "\n      ")]
            )
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }